import React from "react";
import PropTypes from "prop-types";
import styles from "./styles";
import { Typography, withStyles } from "@material-ui/core";
import { translate } from "react-i18next";
import { compose } from "redux";

const Footer = ({ t, classes }) => (
    <div className={classes.footer}>
        <div className={classes.rows}>
            <Typography className={classes.text}>Copyright © Notariaat Elise Visser - Amsterdam</Typography>
            <Typography className={classes.text}>Kvk: 33279679</Typography>
        </div>
        <div className={classes.rows}>
            <Typography className={classes.text}><a className={classes.link} href="/documents/Algemene Voorwaarden Notariaat Elise Visser.pdf" target="_blank">{t("main:terms_and_conditions")}</a></Typography>
            <Typography className={classes.text}><a className={classes.link} href="/documents/Privacybeleid Notariaat Elise Visser.pdf" target="_blank">{t("main:privacy_policy")}</a></Typography>
        </div>
    </div>
);

export default compose(
    translate(),
    withStyles(styles)
)(Footer)

Footer.propTypes = {
    classes: PropTypes.object.isRequired
};
